import http from "./HttpService";

const BASE_SERVICE_URL = "customer-service";

export default {
  register(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/api/v3/customer/register`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  login(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/customer/login/mobile",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  getPublicCustomerToken(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/public/customer/token`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  }
};
